import {Component} from 'vue-property-decorator';
import {LANGTAG} from '../global_vars';
import {makeFormData, simpleObjectCopy} from '../utils/miscellanea';
import * as basicLightbox from 'basiclightbox';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';
import Event from '../utils/Event';
import ContactForm from '../mixins/ContactForm';
import {mixins} from 'vue-class-component';
import {State} from '../utils/fetch';
import {success, warning} from '../utils/Toast';
import Form from '../utils/Form';
import {delay} from '../utils/async';
import 'vue-js-modal';
import FormFile from "../components/form/FormFile";
// import anime from 'animejs/lib/anime.es.js';
// @ts-ignore

interface ContactData {
  name: string;
  phone: string;
  message: string;
  agreement: boolean;
}

@Component({
  components: {
    FormFile
  }
})
export default class BranchForm extends mixins(ContactForm) {

  public form = new Form<ContactData>({
    name: '',
    message: '',
    phone: '',
    agreement: false
  });

  public fileTZ: null | File = null;

  protected requiredFields = ['name', 'phone', 'agreement'];
  protected lbInstance!: basicLightbox.BasicLightBox | null;

  async mounted() {
    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    await delay(500);
  }

  public async send() {
    this.checkForm();

    if (!this.isFormReady) return;
    this.isLoading = true;

    const form = makeFormData(simpleObjectCopy(this.form.data));
    form.append(this._token, '1');
    form.append('type', '4');

    if (this.fileTZ) {
      form.append('file', this.fileTZ);
    }

    const response = await this._http.fetchJSON<any>(`/index.php?option=com_xcm&task=send_message`, {
      method: 'POST',
      body: form
    });

    if (response.state == State.SUCCESS) {
      success(response.body.message);
      this.form.errors.clear();
      this.form.clear();
      location.href = '/ru/franchise/spasibo2';
    } else {
      warning(response.message, 'Ошибка');
    }
  }

  openAgreement(key: string) {
    this.lbInstance = basicLightbox.create(
      document.querySelector(`#agreement`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }
}
